<form [formGroup]="form" class="plm-form">
  <sgt-ciclo-vida-timeline
    [faseAtiva]="faseAtiva"
    [ciclo]="data?.cicloPLM"
  ></sgt-ciclo-vida-timeline>

  <section class="plm-form__card">
    <header class="plm-form__card-header">
      <span class="plm-form__card-icon">
        <i class="fas fa-sliders-h" aria-hidden="true"></i>
      </span>
      <div>
        <h2 class="plm-form__card-title">Configurações de PLM</h2>
        <p class="plm-form__card-subtitle">Parâmetros gerais de classificação do produto</p>
      </div>
    </header>
    <div class="plm-form__grid">
      <div class="plm-form__input-group">
        <label for="idClassificacaoPLMRAP">Classificação RAP</label>
        <sgt-select
          [options]="classificacaoRAP"
          [settings]="{
            placeholder: 'Selecione a classificação RAP',
            isDisabled: !podeEditarDadosPLM
          }"
          formControlName="idClassificacaoPLMRAP"
        ></sgt-select>
        <span class="plm-form__helper-text">
          {{ descricaoClassificacaoRAP }}</span>
      </div>

      <div class="plm-form__input-group">
        <label for="idClassificacaoPLMRAR">Classificação RAR</label>
        <sgt-select
          [options]="classificacaoRAR"
          [settings]="{
            placeholder: 'Selecione a classificação RAR',
            isDisabled: true
          }"
          formControlName="idClassificacaoPLMRAR"
        ></sgt-select>
        <span class="plm-form__helper-text">
          {{ descricaoClassificacaoRAR }}
        </span>
      </div>
    </div>
  </section>

  <section class="plm-form__card">
    <header class="plm-form__card-header">
      <span class="plm-form__card-icon plm-form__card-icon--accent">
        <i class="fas fa-flask" aria-hidden="true"></i>
      </span>
      <div>
        <h2 class="plm-form__card-title">Núcleo Pesquisa &amp; Desenvolvimento</h2>
        <p class="plm-form__card-subtitle">Pesquisa, desenvolvimento e o DNA do produto</p>
      </div>
    </header>

    <div class="plm-form__grid">
      <div class="plm-form__input-group">
        <label for="dataPesquisa">Data da Pesquisa</label>
        <sgt-novo-datepicker
          [ngModelOptions]="{standalone: true}"
          [ngModel]="valoresDatepicker['dataPesquisaPLM']"
          (ngModelChange)="onChangeData('dataPesquisaPLM', $event)"
          [settings]="datepickerSettings"
          [periodicidade]="periodicidadeDiariaId"
          emptyText="__/__/____"
          id="dataPesquisa"
        >
        </sgt-novo-datepicker>
        <span class="plm-form__helper-text">Data de início da pesquisa</span>
      </div>

      <div class="plm-form__input-group">
        <label for="dataDesenvolvimento">Data de Desenvolvimento</label>
         <sgt-novo-datepicker
          [ngModelOptions]="{standalone: true}"
          [ngModel]="valoresDatepicker['dataDesenvolvimentoPLM']"
          (ngModelChange)="onChangeData('dataDesenvolvimentoPLM', $event)"
          [settings]="datepickerSettings"
          [periodicidade]="periodicidadeDiariaId"
          emptyText="__/__/____"
          id="dataDesenvolvimento"
        >
        </sgt-novo-datepicker>
        <span class="plm-form__helper-text">
          Data de início do desenvolvimento
        </span>
      </div>
    </div>

    <div class="plm-form__dna">
      <header class="plm-form__dna-header">
        <span class="plm-form__dna-icon">
          <i class="fas fa-dna" aria-hidden="true"></i>
        </span>
        <div class="plm-form__dna-heading">
          <h3 class="plm-form__dna-title">DNA do Produto</h3>
          <p class="plm-form__dna-subtitle">
            A parametrização do que esperamos do produto ao longo da vida.
          </p>
        </div>
        <span class="plm-form__dna-count">{{ qtdParametrosDna }} parâmetros</span>
      </header>

      <div class="plm-form__dna-body plm-form__dna-body--colunas">
        <sgt-item-dna-heranca
          class="plm-form__dna-heranca"
          [dna]="dna"
          [expectativas]="dnaExpectativas"
          [valoresDoItem]="valoresDoItemParaHeranca"
          [gruposRentabilidade]="gruposRentabilidade"
          [idGrupoRentabilidade]="idGrupoRentabilidade"
          [populacaoDoItem]="populacaoDoItem"
          [podeEditar]="podeEditarDna && podeEditarDadosPLM"
          (vincular)="abrirSeletorDna()"
          (trocar)="abrirSeletorDna(true)"
          (desvincular)="abrirDesvincularDna()"
          (abrirDna)="onAbrirDna($event)"
        ></sgt-item-dna-heranca>

        <div class="plm-form__dna-campos">
        <div
          class="plm-form__pa"
          role="group"
          aria-labelledby="label-publicos-alvo"
        >
          <label id="label-publicos-alvo" class="plm-form__pa-label">
            Públicos-Alvo monitorados
            <i
              class="fas fa-info-circle plm-form__info"
              sgtTooltip="Grupos de clientes que este produto deve monitorar no PLM"
              aria-hidden="true"
            ></i>
          </label>
          <div class="plm-form__pa-list">
            <span
              *ngFor="let publicoAlvo of publicosAlvoSelecionados; trackBy: trackPublicoAlvoById"
              class="plm-form__pa-chip"
            >
              {{ publicoAlvo.nome }}
              <button
                type="button"
                class="plm-form__pa-chip-remove"
                [disabled]="!podeEditarDadosPLM"
                sgtTooltip="Remover público-alvo"
                [attr.aria-label]="'Remover ' + publicoAlvo.nome"
                (click)="removerPublicoAlvo(publicoAlvo.id)"
              >
                <i class="fas fa-times" aria-hidden="true"></i>
              </button>
            </span>

            <button
              type="button"
              class="plm-form__pa-add"
              [disabled]="!podeEditarDadosPLM"
              aria-labelledby="label-publicos-alvo"
              (click)="abrirSeletorPublicoAlvo()"
            >
              <i class="fas fa-plus" aria-hidden="true"></i> Público-Alvo
            </button>
          </div>
        </div>

        <div class="plm-form__grid plm-form__grid--cols-1">
          <div class="plm-form__input-group">
            <label for="tipoEstrategicoPLM">Tipo Estratégico</label>
            <sgt-select
              [options]="tipoEstrategicoPLM"
              [settings]="{
                placeholder: 'Selecione o tipo estratégico',
                isDisabled: !podeEditarDadosPLM,
                isClearSelectionAllowed: true
              }"
              formControlName="tipoEstrategicoPLM"
            ></sgt-select>
            <span class="plm-form__helper-text">
              {{ descricaoTipoEstrategico }}</span>
          </div>
        </div>

        <div class="plm-form__grid plm-form__grid--cols-2">
          <div class="plm-form__input-group">
            <label for="taxaAdocaoPLM">
              Taxa de Adoção
              <i
                class="fas fa-info-circle plm-form__info"
                sgtTooltip="Percentual esperado dos públicos-alvo que devem experimentar o produto"
                aria-hidden="true"
              ></i>
            </label>
            <div class="plm-form__stepper">
              <button
                type="button"
                class="plm-form__stepper-botao"
                [disabled]="campoDesabilitado('taxaAdocaoPLM')"
                aria-label="Diminuir a taxa de adoção"
                (click)="passoTaxa('taxaAdocaoPLM', -passoTaxaPadrao)"
              >
                <i class="fas fa-minus" aria-hidden="true"></i>
              </button>
              <span class="plm-form__stepper-valor">
                <input
                  id="taxaAdocaoPLM"
                  class="plm-form__stepper-campo"
                  type="text"
                  inputmode="decimal"
                  formControlName="taxaAdocaoPLM"
                  [size]="tamanhoInput('taxaAdocaoPLM')"
                  sgtPercentInput
                  [decimals]="2"
                  [max]="100"
                />
                <span class="plm-form__stepper-sufixo">%</span>
              </span>
              <button
                type="button"
                class="plm-form__stepper-botao"
                [disabled]="campoDesabilitado('taxaAdocaoPLM')"
                aria-label="Aumentar a taxa de adoção"
                (click)="passoTaxa('taxaAdocaoPLM', passoTaxaPadrao)"
              >
                <i class="fas fa-plus" aria-hidden="true"></i>
              </button>
            </div>
          </div>

          <div class="plm-form__input-group">
            <label for="pesoMedioMaturacaoPLM">
              Peso Médio de Maturação
              <i
                class="fas fa-info-circle plm-form__info"
                sgtTooltip="Peso médio esperado para o produto alcançar o patamar de maduro"
                aria-hidden="true"
              ></i>
            </label>
            <div class="plm-form__stepper">
              <button
                type="button"
                class="plm-form__stepper-botao"
                [disabled]="campoDesabilitado('pesoMedioMaturacaoPLM')"
                aria-label="Diminuir o peso médio de maturação"
                (click)="passoPesoMedio(-1)"
              >
                <i class="fas fa-minus" aria-hidden="true"></i>
              </button>
              <span class="plm-form__stepper-valor">
                <input
                  id="pesoMedioMaturacaoPLM"
                  class="plm-form__stepper-campo"
                  type="text"
                  inputmode="decimal"
                  formControlName="pesoMedioMaturacaoPLM"
                  [size]="tamanhoInput('pesoMedioMaturacaoPLM')"
                  sgtPercentInput
                  [decimals]="6"
                />
                <span class="plm-form__stepper-sufixo">KG</span>
              </span>
              <button
                type="button"
                class="plm-form__stepper-botao"
                [disabled]="campoDesabilitado('pesoMedioMaturacaoPLM')"
                aria-label="Aumentar o peso médio de maturação"
                (click)="passoPesoMedio(1)"
              >
                <i class="fas fa-plus" aria-hidden="true"></i>
              </button>
            </div>
          </div>
        </div>

        <div
          class="plm-form__taxas"
          role="group"
          aria-labelledby="label-taxas-maturacao"
        >
          <label id="label-taxas-maturacao" class="plm-form__taxas-label">Taxas de maturação</label>
          <div class="plm-form__grid plm-form__grid--cols-2">
            <div
              class="plm-form__input-group"
              *ngFor="let fase of fasesMaturacao; trackBy: trackFaseByControle"
            >
              <label [attr.for]="fase.controle">
                {{ fase.rotulo }}
                <i
                  class="fas fa-info-circle plm-form__info"
                  [sgtTooltip]="'Percentual do peso maduro esperado na fase de ' + fase.rotuloMinusculo"
                  aria-hidden="true"
                ></i>
              </label>
              <div class="plm-form__stepper">
                <button
                  type="button"
                  class="plm-form__stepper-botao"
                  [disabled]="campoDesabilitado(fase.controle)"
                  [attr.aria-label]="'Diminuir a taxa de maturação no ' + fase.rotuloMinusculo"
                  (click)="passoTaxa(fase.controle, -passoTaxaPadrao)"
                >
                  <i class="fas fa-minus" aria-hidden="true"></i>
                </button>
                <span class="plm-form__stepper-valor">
                  <input
                    [id]="fase.controle"
                    class="plm-form__stepper-campo"
                    type="text"
                    inputmode="decimal"
                    [formControlName]="fase.controle"
                    [size]="tamanhoInput(fase.controle)"
                    sgtPercentInput
                    [decimals]="2"
                    [max]="100"
                  />
                  <span class="plm-form__stepper-sufixo">%</span>
                </span>
                <button
                  type="button"
                  class="plm-form__stepper-botao"
                  [disabled]="campoDesabilitado(fase.controle)"
                  [attr.aria-label]="'Aumentar a taxa de maturação no ' + fase.rotuloMinusculo"
                  (click)="passoTaxa(fase.controle, passoTaxaPadrao)"
                >
                  <i class="fas fa-plus" aria-hidden="true"></i>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="plm-form__grid" *ngIf="exibirGrupoRentabilidade">
          <div class="plm-form__input-group">
            <label for="idGrupoRentabilidade">
              Grupo de Rentabilidade
              <i
                class="fas fa-info-circle plm-form__info"
                sgtTooltip="Base para o indicador de Contribuição de Valor (ICV)"
                aria-hidden="true"
              ></i>
            </label>
            <sgt-grupo-rentabilidade-select
              id="idGrupoRentabilidade"
              name="idGrupoRentabilidade"
              [ngModelOptions]="{ standalone: true }"
              [ngModel]="idGrupoRentabilidade"
              (ngModelChange)="onChangeGrupoRentabilidade($event)"
              [isDisabled]="!podeEditarGrupoRentabilidade || !podeEditarDadosPLM"
            ></sgt-grupo-rentabilidade-select>
          </div>
        </div>

        </div>
      </div>
    </div>
  </section>

  <section class="plm-form__card">
    <header class="plm-form__card-header">
      <span class="plm-form__card-icon">
        <i class="fas fa-bullseye" aria-hidden="true"></i>
      </span>
      <div>
        <h2 class="plm-form__card-title">Núcleo Go-To-Market</h2>
        <p class="plm-form__card-subtitle">Informações do núcleo de Go-To-Market do produto</p>
      </div>
    </header>
    <div class="plm-form__grid">
      <div class="plm-form__input-group">
        <label for="dataGoToMarket">Data Go-To-Market</label>
        <sgt-novo-datepicker
          [ngModelOptions]="{standalone: true}"
          [ngModel]="valoresDatepicker['dataGoToMarketPLM']"
          (ngModelChange)="onChangeData('dataGoToMarketPLM', $event)"
          [settings]="datepickerSettings"
          [periodicidade]="periodicidadeDiariaId"
          emptyText="__/__/____"
          id="dataGoToMarket"
        >
        </sgt-novo-datepicker>
        <span class="plm-form__helper-text"
          >Data de início do Go-To-Market</span
        >
      </div>
    </div>
  </section>

  <section class="plm-form__card">
    <header class="plm-form__card-header">
      <span class="plm-form__card-icon">
        <i class="fas fa-rocket" aria-hidden="true"></i>
      </span>
      <div>
        <h2 class="plm-form__card-title">Núcleo Desempenho</h2>
        <p class="plm-form__card-subtitle">Informações do núcleo de Desempenho do produto</p>
      </div>
    </header>
    <div class="plm-form__grid">
      <div class="plm-form__input-group">
        <label for="dataNascimento">Data Nascimento</label>
        <sgt-novo-datepicker
          [ngModelOptions]="{standalone: true}"
          [ngModel]="valoresDatepicker['dataNascimentoPLM']"
          (ngModelChange)="onChangeData('dataNascimentoPLM', $event)"
          [settings]="datepickerSettings"
          [periodicidade]="periodicidadeDiariaId"
          emptyText="__/__/____"
          id="dataNascimento"
        >
        </sgt-novo-datepicker>
        <span class="plm-form__helper-text">
          Data de nascimento do produto
        </span>
      </div>

      <div class="plm-form__input-group">
        <label for="dataEncerramento">Data Encerramento</label>
        <sgt-novo-datepicker
          [ngModelOptions]="{standalone: true}"
          [ngModel]="valoresDatepicker['dataEncerramentoPLM']"
          (ngModelChange)="onChangeData('dataEncerramentoPLM', $event)"
          [settings]="datepickerDerivadoSettings"
          [periodicidade]="periodicidadeDiariaId"
          emptyText="__/__/____"
          id="dataEncerramento"
        >
        </sgt-novo-datepicker>
        <span class="plm-form__helper-text"
          >Data de início do encerramento</span
        >
      </div>
    </div>
  </section>

  <sgt-modal
    [isOpen]="seletorPublicoAlvoAberto"
    [settings]="modalPublicoAlvoSettings"
    (closed)="fecharSeletorPublicoAlvo()"
  >
    <sgt-publico-alvo-select
      *ngIf="seletorPublicoAlvoAberto"
      body
      [idsJaSelecionados]="idsPublicosAlvoSelecionados"
      (concluir)="onPublicosAlvoSelecionados($event)"
      (fechar)="fecharSeletorPublicoAlvo()"
    ></sgt-publico-alvo-select>
  </sgt-modal>

  <sgt-modal
    [isOpen]="seletorDnaAberto"
    [settings]="modalDnaSettings"
    (closed)="fecharSeletorDna()"
  >
    <sgt-dna-select
      *ngIf="seletorDnaAberto"
      body
      [trocaDe]="dnaEmTroca"
      [nomeSku]="nomeItem"
      [nomeDnaAtual]="dna?.nome"
      [gruposRentabilidade]="gruposRentabilidade"
      (confirmar)="onDnaSelecionado($event)"
      (fechar)="fecharSeletorDna()"
    ></sgt-dna-select>
  </sgt-modal>

  <sgt-modal
    [isOpen]="desvincularDnaAberto && !!dna"
    [settings]="modalDesvincularSettings"
    (closed)="fecharDesvincularDna()"
  >
    <sgt-dna-desvincular
      *ngIf="desvincularDnaAberto && dna"
      body
      [nomeDna]="dna.nome"
      [parametrosMutados]="parametrosMutados"
      (confirmar)="onDesvincularDna()"
      (fechar)="fecharDesvincularDna()"
    ></sgt-dna-desvincular>
  </sgt-modal>
</form>
